/* eslint-disable unicorn/filename-case -- TODO rename later */
import { MutationCache, QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      // Skip global invalidation for mutations marked with skipGlobalInvalidation
      if (mutation.meta?.skipGlobalInvalidation) {
        return;
      }
      queryClient.invalidateQueries();
    },
  }),
});
